import {
  isProvenanceForbidden,
  usePipelineProvenance,
} from "@via/api/git-provenance.api.tsx";
import GitProvenancePanel from "@via/components/git-provenance/git-provenance-panel.tsx";
import { JSX } from "react";
import { useParams } from "react-router-dom";

/** The pipeline page's Provenance tab (git-4-2): the revision in the route, read only. */
export default function PipelineProvenance(): JSX.Element {
  const { pipelineId: pipelineIdParam } = useParams();
  const { data, isLoading, isError, error } = usePipelineProvenance(
    Number(pipelineIdParam)
  );
  return (
    <GitProvenancePanel
      subject="pipeline"
      data={data}
      isLoading={isLoading}
      isError={isError}
      isForbidden={isProvenanceForbidden(error)}
    />
  );
}
